export default {
    caseData: 1,
    employeeData: 2,
    officeAddress: 3,
    caseEventData: 4,
}
